import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';
import cx from 'clsx';
import { ContactLabel } from './ContactLabel';
import * as styles from './styles.module.css';

/**
 * Компонент для выстраивания набора лейблов в Контакте
 * Используется совместно с набором ContactLabel в children
 *
 * Адаптивный
 * Использует useDeviceType из ui-kit
 * В мобильной версии лейблы выстраиваются вертикально
 */
export function ContactLabels(props) {
  var deviceType = useDeviceType();
  var labels = props.labels.filter(Boolean);
  var isVertical = deviceType === 'phone';

  if (!labels.length) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: cx(styles['labels'], isVertical && styles['vertical'])
  }, labels.map(function (label, i) {
    return /*#__PURE__*/React.createElement("div", {
      key: i,
      className: styles['label']
    }, /*#__PURE__*/React.createElement(ContactLabel, label));
  }));
}